import { Language } from '@lib/graphql/__generated__/graphql'
import { setDefaultOptions } from 'date-fns'
import { bg, enUS, fr } from 'date-fns/locale'
import { useEffect } from 'react'

const locales = {
  [Language.En]: enUS,
  [Language.Bg]: bg,
  [Language.Fr]: fr,
}

const useDateOptions = ({ lang }: { lang: string }) => {
  useEffect(() => {
    setDefaultOptions({
      weekStartsOn: 1,
      locale: lang ? locales[lang] || enUS : enUS,
    })
  }, [lang])
}

export default useDateOptions
